// This is tiny, but it is exported here for individual testing

export const getShortTimezone = (localeDateString: string) => {
  const splitDate = localeDateString.split(' ')

  // The timezone is always given last
  return splitDate[splitDate.length - 1]
}
